import { useEffect, useState, useContext } from 'react';
import { useRouteLoaderData, NavLink } from "react-router-dom";

import { getLabConfig } from '../../utils/api';
import FileDisplay from '../../utils/FileDisplay';
import LabIDContext from '../../store/LabIDContext';
import OrderComplete from './OrderComplete';

const Success = (props) => {
	const token = useRouteLoaderData('root');
	const labid = useContext(LabIDContext);

	const reqNumber = props.reqdata.orderInfo.reqnum;
	const phStatus = props.reqdata.orderInfo.status
	console.log(props.reqdata.orderInfo);
    return (
       <div>
			 <FileDisplay filePath={`./${labid}_Complete.js`} labid={labid} />
			{props.reqdata.orderInfo.success && <OrderComplete reqNumber={reqNumber} token={token} orderinfo= {props.reqdata.orderInfo} />}
			{props.reqdata.orderInfo.errors && <p> Order errored. {props.reqdata.orderInfo.errors}</p>}
			{phStatus === "CYNERGY Rejected" && (<div>Your order has been denied by the approving physician service.  Your credit card payment should be reversed, but may take several days to appear.</div>)}
			{phStatus === "i3Screen Rejected" && (<div>Your order has been denied by i3Screen.  </div>)}
			{phStatus === "No qualifying Order Code Found" && (<div>Your order does not qualify for self-testing.  Your credit card payment should be reversed, but may take several days to appear.</div>)}
			{!props.reqdata.orderInfo.success && phStatus === "Submitted" && (<div>Your order is currently being reviewed by our physician service.  This should only take a few minutes. Please click <NavLink to='../cynergy' state={{orderInfo: reqNumber}}>here</NavLink> to refresh the screen and see your status.</div>)}
		</div>
    );
};

export default Success;
